import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading, user, isAuth, handleLogin, handleLogout, socket, getCurrentUserInfo,
		loginStep, totpSecret, handleNewPassword, handleMfaSetup, handleMfaVerify,
		handleForgotPassword, handleResetPassword, goBackToLogin, goToForgotPassword,
		authEmail, mfaRecoveryInfo, mfaRecoveryExpiresAt, goToMfaRecovery,
		handleRequestMfaRecovery, handleVerifyMfaRecovery, exitMfaRecovery,
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading, user, isAuth, handleLogin, handleLogout, socket, getCurrentUserInfo,
				loginStep, totpSecret, handleNewPassword, handleMfaSetup, handleMfaVerify,
				handleForgotPassword, handleResetPassword, goBackToLogin, goToForgotPassword,
				authEmail, mfaRecoveryInfo, mfaRecoveryExpiresAt, goToMfaRecovery,
				handleRequestMfaRecovery, handleVerifyMfaRecovery, exitMfaRecovery,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };